export enum StreckengrafikRenderingType {
  TimeScaledDistance,
  UniformDistance,
}
